import React, { useContext, useEffect, useState } from 'react'
import { apiGet } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import Pagination from '../Pagination'
import { useTranslation } from 'react-i18next'
import MarketingList from './MarketingList'
import MarketingView from './MarketingView'
import AddMarketing from './AddMarketing'
import AuthContext from 'context/AuthContext'
function Marketing () {
  const { t } = useTranslation()
  const { user } = useContext(AuthContext)
  const manager =
    user?.permission?.find(e => e.manager === 'marketing_material_manager') ??
    {}
  const [showModal, setShowModal] = useState(false)
  const [viewShow, setViewShow] = useState(false)

  const [subAdmin, setSubAdmin] = useState([])
  const [page, setPage] = useState(1)
  const [pageSize] = useState(10)
  const [item, setItem] = useState('')
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })
  const [sort, setSort] = useState({
    sort_key: 'createdAt',
    sort_type: 'desc'
  })

  const allMarketing = async data => {
    try {
      const payload = {
        page,
        page_size: pageSize
      }

      const path = apiPath.marketingList
      const result = await apiGet(path, payload)
      const response = result?.data?.results
      const resultStatus = result?.data?.success
      setSubAdmin(response?.docs)
      setPaginationObj({
        ...paginationObj,
        page: resultStatus ? response.page : null,
        pageCount: resultStatus ? response.totalPages : null,
        perPageItem: resultStatus ? response?.docs.length : null,
        totalItems: resultStatus ? response.totalDocs : null
      })
      // }
    } catch (error) {
      console.log('error in get all users list==>>>>', error.message)
    }
  }
  const handlePageClick = event => {
    const newPage = event.selected + 1
    setPage(newPage)
  }
  const handelEdit = newItem => {
    setItem(newItem)
    // setEditShowModal(true)
  }

  const handleUserView = newItem => {
    setItem(newItem)
    setViewShow(true)
  }

  useEffect(() => {
    allMarketing()
  }, [page, sort])

  return (
    <div>
      <div className='bg-white'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] '>
            <form className='border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3'>
              <div className='2xl:ml-auto xl:ml-0 lg:pt-0 pt-2'>
                <div className='flex'>
                  {/* filter section */}
                  {(manager?.add || user?.role === 'admin') && (
                    <button
                      title={t('O_ADD_MARKETING')}
                      type='button'
                      style={{ marginLeft: 'auto' }}
                      className='ml-auto block bg-[#8FC150] flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] whitespace-nowrap'
                      onClick={() => setShowModal(true)}
                    >
                      + {t('O_ADD_MARKETING')}
                    </button>
                  )}
                </div>
              </div>
            </form>
            <MarketingList
              subAdmin={subAdmin}
              handelEdit={handelEdit}
              allSubAdmin={allMarketing}
              handleUserView={handleUserView}
              page={page}
              setSort={setSort}
              sort={sort}
              manager={manager}
              paginationObj={paginationObj}
            />
            {paginationObj?.totalItems !== 0 && (
              <Pagination
                handlePageClick={handlePageClick}
                options={paginationObj}
                // isDelete={isDelete}
                page={page}
              />
            )}
          </div>
        </div>
      </div>
      <>
        {showModal && (
          <AddMarketing
            setShowModal={setShowModal}
            allMarketing={allMarketing}
          />
        )}
        {viewShow && <MarketingView setViewShow={setViewShow} item={item} />}
      </>
    </div>
  )
}

export default Marketing
